import { API } from '../api/axios'

export const ssoBridge = (body: JsonString<SsoBridgeBody>) => {
	API({
		url: 'sso',
		method: 'POST',
		body
	}).then((res: SsoBridgeRes) => {
		const parser = new DOMParser()
		const doc = parser.parseFromString(res.ssoForm, 'text/html')

		// setup script element
		// ios safari requires a timeout to open a new window
		setTimeout(() => {
			var win = window.open('')
			const scriptTag = doc.querySelector('script')

			if (!win) {
				window.LogRocket.track('errorSSO', {
					errorType: 'bridgeWindow'
				})
				return
			}

			if (!scriptTag) return

			const scriptContent = scriptTag.textContent
			const ssoScript = win.document.createElement('script')
			ssoScript.id = 'ssoScript'
			ssoScript.textContent = scriptContent

			// consume form and script
			const bodyContent = doc.querySelector('form')

			if (!bodyContent) return
			doc.getElementById('ssoForm')
			win.document.body.appendChild(bodyContent)
			win.document.head.appendChild(ssoScript)
			win.document.body.removeChild(bodyContent)
			win.document.head.removeChild(ssoScript)
		})
	})
}
